import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const LoanIdentityQueueRowSchema = withDefaults({
  type: 'loan-identity-queue-row',
  objectExtensions: ['loan-identity-queue-row'],
  fields: [
    { kind: 'attribute', name: 'status' },
    { kind: 'attribute', name: 'rawText' },
    { kind: 'attribute', name: 'holdReason' },
    { kind: 'attribute', name: 'personId' },
    { kind: 'attribute', name: 'personName' },
    { kind: 'attribute', name: 'documentId' },
    { kind: 'attribute', name: 'documentProvider' },
    { kind: 'attribute', name: 'documentReflectionState' },
    { kind: 'attribute', name: 'documentUploadedAt' },
    { kind: 'attribute', name: 'accountId' },
    { kind: 'attribute', name: 'answer' },
    { kind: 'attribute', name: 'heldLoan' },
    { kind: 'attribute', name: 'existingLoans' },
    { kind: 'attribute', name: 'submittedAt' },
    { kind: 'attribute', name: 'answeredAt' },
    { kind: 'attribute', name: 'appliedAt' },
  ],
});

export default LoanIdentityQueueRowSchema;
